<template>
  <q-layout view="hHh Lpr lFf">
    <q-header elevated>
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          {{ $appTitle }}
           <div style="opacity: 0.7" class="text-subtitle2">{{subTitle}}</div>
        </q-toolbar-title>

        <div>
          <q-btn flat round dense icon="menu" @click="rightDrawerOpen = !rightDrawerOpen" aria-label="Toggle menu on right side" />
        </div>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      content-class="bg-grey-2"
    >
      <MainMenu></MainMenu>
    </q-drawer>

    <q-drawer side="right" v-model="rightDrawerOpen" content-class="bg-grey-2" >
    <keep-alive>
      <component :is=SideDialog v-bind:Entity="Entity"></component>
    </keep-alive>
    </q-drawer>

    <q-page-container>
      <keep-alive>
        <router-view/>
      </keep-alive>
    </q-page-container>
  </q-layout> 
</template>

<script>
import MainMenu from './components/MainMenu.vue'
import SideDialogWelcome from './components/SideDialogWelcome.vue'
import UnitCommandDialog from  './components/Dialog/UnitCommandDialog'
import AlertEditor from  './components/Dialog/AlertEditor'
import CreateMaintenanceSchedule from './components/Dialog/CreateMaintenanceSchedule'
import EntityEditor from  './components/Dialog/EntityEditor'
import ExportTrack from  './components/Dialog/ExportTrack'

import {eventBus} from './main'

export default {
  name: 'LayoutDefault',

  components: {
    MainMenu,
    SideDialogWelcome
  },

  data () {
    return {
      leftDrawerOpen: false,
      rightDrawerOpen: false,
      SideDialog: 'SideDialogWelcome',
      Entity: null, 
    }
  },
  methods: {
    
  },
  computed: {
    // a computed getter
    subTitle: function () {
      if(!this.$store.state.session)
        return this.$t("global.hello")
       else
         return  this.$store.state.session.CustomerName + " - " + this.$t("global.hello")
    }
  },
  watch: {
    leftDrawerOpen: function (val) {     
      //When we close the left drawer we fire a windows resize even wiht a 250ms delay, this fixes issues wiht the leaflet map.
      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    },
    rightDrawerOpen: function (val) {
      //When we close the left drawer we fire a windows resize even wiht a 250ms delay, this fixes issues wiht the leaflet map.
      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    },
  },
  created () { 
    eventBus.$on('UnitCommandDialog', (data) => {
      this.Entity = data
      this.SideDialog = UnitCommandDialog
      this.rightDrawerOpen = true
    }),
    eventBus.$on('AlertEdit', (data) => {
      this.Entity = data
      this.SideDialog = AlertEditor
      this.rightDrawerOpen = true
    }),
    eventBus.$on('loadDialog', (data) => {
      if(data == 'CreateMaintenanceSchedule'){
        this.SideDialog = CreateMaintenanceSchedule
        this.rightDrawerOpen = true
      }
      if(data == 'MaintenanceGroup'){
        this.Entity = { entity: 'MaintenanceGroup', id: null }
        this.SideDialog = EntityEditor
        this.rightDrawerOpen = true
      }
      if(data == 'ExportTrack'){
        this.SideDialog = ExportTrack
        this.rightDrawerOpen = true
      }  
    })

    //window.addEventListener("beforeinstallprompt", e => {
    //  e.preventDefault();
    //  this.deferredPrompt = e;
    //})

  }
}
</script>

<style>
</style>
